import React from "react";

const Stats = ({ appData }) => {
  const stats = [
    {
      label: "Minutes Today",
      value: appData.stats.todayMinutes,
      color: "bg-gradient-to-br from-blue-500 to-blue-600",
      icon: "ph-calendar-check",
    },
    {
      label: "This Week",
      value: appData.stats.weekMinutes,
      color: "bg-gradient-to-br from-green-500 to-green-600",
      icon: "ph-calendar",
    },
    {
      label: "Total Sessions",
      value: appData.stats.totalSessions,
      color: "bg-gradient-to-br from-purple-500 to-purple-600",
      icon: "ph-target",
    },
    {
      label: "Day Streak",
      value: appData.stats.streak,
      color: "bg-gradient-to-br from-orange-500 to-orange-600",
      icon: "ph-fire",
    },
  ];

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6">
      <div className="flex items-center gap-2 mb-6">
        <i className="ph ph-chart-bar text-gray-700 text-xl"></i>
        <h2 className="text-xl font-bold text-gray-900">Statistics</h2>
      </div>

      <div className="space-y-4">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="p-5 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200"
          >
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-600 mb-1">
                  {stat.label}
                </p>
                <p className="text-3xl font-bold text-gray-900">{stat.value}</p>
              </div>
              <div
                className={`w-14 h-14 ${stat.color} rounded-xl flex items-center justify-center shadow-lg`}
              >
                <i className={`ph ${stat.icon} text-white text-2xl`}></i>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-6 bg-gradient-to-br from-slate-800 to-slate-900 text-white rounded-xl">
        <div className="flex items-center gap-2 mb-3">
          <i className="ph ph-clock text-white text-xl"></i>
          <h3 className="font-bold text-lg">Total Focus Time</h3>
        </div>
        <p className="text-3xl font-bold">
          {Math.floor(appData.stats.totalMinutes / 60)}h{" "}
          {appData.stats.totalMinutes % 60}m
        </p>
        <p className="text-slate-300 text-sm mt-1">All-time productivity</p>
      </div>
    </div>
  );
};

export default Stats;
